import React from 'react'

export default function Bg() {
  return (
    <div className='bg-section h-screen w-screen absolute z-0 overflow-hidden'></div>
  )
}
